import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class BrokerCode {

  @JsonProperty()
  id: number = -1;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  broker: string | undefined;

  @JsonProperty()
  exchangeCode: string | undefined;

  @JsonProperty()
  clearingHouse: string | undefined;

  @JsonProperty()
  email: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
